<template>
  <div id="new-campaign-form">
    <vx-card>
      <h3 v-if="!editMode" class="mb-8">Agregar campaña</h3>
      <h3 v-if="editMode" class="mb-8">Editar campaña</h3>
      <div class="vx-row">
        <div :class="colClass">
          <vs-input class="w-full" label="Nombre de la campaña *" placeholder="(Requerido)" name="cat_title"
            v-model.lazy="campaign.name" :danger="hasError('cat_title')" :danger-text="errorText('cat_title')"
            :success="isSuccess('cat_title')" icon-pack="feather"></vs-input>
        </div>
        <div :class="colClass">
          <label for="types">Tipo *</label>
          <v-select name="types" class="vs-custom"
            :class="{ 'has-error': hasError('cat_type'), 'is-success': isSuccess('cat_type') }"
            v-model.lazy="campaign.type" :placeholder="placeholder" :options="types" label="type" :clearable="false"
            :searchable="false" id="types">
          </v-select>
        </div>
        <div :class="colClass">
          <label for="from">Remitente *</label>
            <v-select name="from" class="vs-custom"
            :class="{ 'has-error': hasError('cat_type'), 'is-success': isSuccess('cat_type') }" v-model.lazy="from"
            :placeholder="placeholder" :options="fromCatalog" label="email" :clearable="false" :searchable="false"
            id="from">
          </v-select>
        </div>
        <div :class="colClass">
          <vs-input class="w-full" label="Alias remitente *" placeholder="(Requerido)" name="cat_title"
            v-model.lazy="from.name" :danger="hasError('cat_title')" :danger-text="errorText('cat_title')"
            :success="isSuccess('cat_title')" icon-pack="feather"></vs-input>
        </div>
        <div :class="fullColClass">
          <label for="email_marketing_template_id">Plantilla de correo *</label>
          <v-select name="email_marketing_template_id" class="vs-custom"
            :class="{ 'has-error': hasError('cat_type'), 'is-success': isSuccess('cat_type') }"
            v-model.lazy="campaign.email_marketing_template_id" :options="emailTemplatesCatalog"
            :reduce="(option) => parseInt(option.id)" :placeholder="placeholder" label="label" :clearable="false"
            :searchable="true" id="email_marketing_template_id">
          </v-select>
        </div>
        <div :class="fullColClass">
          <label for="audience_id">Audiencia *</label>
          <v-select name="audience_id" class="vs-custom"
            :class="{ 'has-error': hasError('cat_type'), 'is-success': isSuccess('cat_type') }"
            v-model.lazy="campaign.audience_id" :options="audiencesCatalog" :placeholder="placeholder"
            label="description" :reduce="item => item.id" :clearable="false" :searchable="true" id="audience_id">
          </v-select>

          <span v-if="templateTested">
            Se encontraron {{ targets.length }} objetivos. <br /><br />
            <code>Ejemplo: {{ targetTemplate }}</code>
          </span>
        </div>
        <div :class="colClass" class="mt-base">
          <vs-checkbox v-model="wantScheduleCampaign">Programar envío</vs-checkbox>
        </div>
        <div :class="colClass" v-if="wantScheduleCampaign">
          <label for="schedule_date">Programar envío</label>
          <div class="row">
            <div class="col-12">
              <datetime format="YYYY-MM-DD hh:mm" v-model='campaign.schedule_date'></datetime>
            </div>
          </div>
        </div>
        <div class="vx-col w-full">
          <vs-button :disabled="saveIsDisabled" v-if="!editMode" class="mt-8" @click="createCampaign()">
            Guardar
          </vs-button>
          <vs-button v-else class="mt-3" @click="editCampaign()">
            Actualizar
          </vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import datetime from 'vuejs-datetimepicker';

export default {
  name: "Form",
  components: {
    datetime,
  },
  data: () => ({
    colClass: "vx-col sm:w-full md:w-1/2 mb-2",
    fullColClass: "vx-col w-full mb-2",
    placeholder: "Selecciona una opción",
    templateTested: false,
    audiencesCatalog: [],
    wantScheduleCampaign: false,
    emailTemplatesCatalog: [],
    targets: [],
    from: {
      name: null,
      email: null
    },
    fromCatalog: [
      {
        name: 'Equipo de RedGirasol',
        email: 'no-responder@redgirasol.com'
      },
      {
        name: 'Marisol de RedGirasol',
        email: 'contacto@redgirasol.com'
      },
      {
        name: 'Angie de RedGirasol',
        email: 'ajardines@redgirasol.com'
      },
      // {
      //   name: 'Mau de RedGirasol',
      //   email: 'mvaldez@redgirasol.com'
      // },
      {
        name: 'Equipo RedGirasol',
        email: 'proyectos@redgirasol.com'
      },
      {
        name: 'Equipo RedGirasol',
        email: 'cobranza@redgirasol.com'
      },
      {
        name: 'Equipo RedGirasol',
        email: 'solar@redgirasol.com'
      }
    ],
    types: [
      'promotions',
      'notifications'
    ],
    campaign: {
      id: null,
      audience_id: null, // ok
      type: null,
      name: null, //ok
      from_name: null,
      from_email: null,
      email_marketing_template_id: null, //ok
      schedule_date: null
    },
  }),
  props: {
    editMode: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    wantScheduleCampaign(value) {
      if (!value) {
        this.campaign.schedule_date = null;
      }
    },
    from(value) {
      this.campaign.from_email = value.email;
      this.campaign.from_name = value.name;
    },
  },
  async mounted() {
    const { data } = await axios.get(`/api/app-http-services/services/notifications/email/audiences`)
    this.audiencesCatalog = data;

    await axios.get(`/api/app-http-services/services/notifications/email/templates-headers`).then((result) => {
      for (const row of result.data) {
        this.emailTemplatesCatalog.push({
          id: row.id,
          label: `${row.id} | ${row.name}`
        });
      }
    });
  },
  computed: {
    saveIsDisabled() {
      return (this.campaign.name == null
        || this.campaign.from_email == null
        || this.campaign.audience_id == null
        || this.campaign.type == null
        || this.campaign.email_marketing_template_id == null);
    }
  },
  methods: {
    async createCampaign() {
      try {
        this.startLoading();
        this.setCampaign();

        await axios.post(`/api/app-http-services/services/notifications/email/campaigns`, this.campaign)
        
        this.campaign = {
          id: null,
          audience_id: null, // ok
          type: null,
          name: null, //ok
          from_name: null,
          from_email: null,
          email_marketing_template_id: null, //ok
          schedule_date: null
        };

        this.$emit("updated");
        this.saveSuccessNotif();

      } catch (e) {
        if (e.response.status === 422) {
          await swal("Notificación", JSON.stringify(e.response.data.errors), "warning")
        }
        if (e.response.status === 500) {
          await swal("Error", "Hubo un error al guardar la campaña", "error")
        }
      }
      this.stopLoading();
    },
    async editCampaign() {
      try {
        this.startLoading();
        this.setCampaign();

        await axios.put(`/api/app-http-services/services/notifications/email/campaigns/${this.campaign.id}`, this.campaign)

        this.campaign = {
          id: null,
          audience_id: null, // ok
          type: null,
          name: null, //ok
          from_name: null,
          from_email: null,
          email_marketing_template_id: null, //ok
          schedule_date: null
        };
        
        this.$emit("updated");
        this.saveSuccessNotif();

      } catch (e) {
        if (e.response.status === 422) {
          await swal("Notificación", JSON.stringify(e.response.data.errors), "warning")
        }
        if (e.response.status === 500) {
          await swal("Error", "Hubo un error al guardar la campaña", "error")
        }
      }
      this.stopLoading();
    },
    hasError(key) {
      //console.log(key);
    },
    errorText(key) {
      //console.log(key);
    },
    isSuccess(key) {
      //console.log(key);
    },
    setCampaign() {
      this.campaign.from_email = this.from.email;
      this.campaign.from_name = this.from.name;
    }
  },
}
</script>

<style>
.datetime-picker {
  width: 100% !important;
  height: 100% !important;
}

.datetime-picker input {
  width: 100% !important;
  padding: 0.7rem !important;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: #626262;
  line-height: 43px !important;
  height: 100% !important;
}
</style>
